<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
      <swiper-slide class="swiper_slide_item" v-for="(image, index) in tour.img" :key="index">
        <div class="imgbox">
          <img :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/' + image.filename + '.jpg'">
        </div>
      </swiper-slide>
      <!-- <swiper-slide class="swiper_slide_item">
        <img src="@/assets/img/02.jpg">
      </swiper-slide>
      <swiper-slide class="swiper_slide_item">
        <img src="@/assets/img/03.jpg">
      </swiper-slide> -->
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <!-- <div v-if="tour.img.length===1">
      <b-row>
        <b-col v-for="(image, index) in tour.img" :key="index">
          <b-img fluid :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/' + tour.img[0].filename + '.jpg'"></b-img>
        </b-col>
      </b-row>
    </div> -->
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  props: {
    tour: {
      type: Object,
      required: true
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data () {
    return {
      swiperOption: {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true
        },
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        breakpoints: {
          768: {
            slidesPerView: 3
          },
          576: {
            slidesPerView: 2
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
#mySwiper {
  // .swiper-slide {
  //   height: 240px;
  //   overflow: hidden;
  // }
  img {
    width: 100%;
    // object-fit: cover;
    // height: 243px;
  }
  .swiper-button-prev,
  .swiper-button-next {
    color: white;
    // border-radius: 50px;
    // padding: 15px;
    // border: 1px solid;
  }
  --swiper-navigation-size: 15px;
  // .swiper-pagination-bullet-active {
  //   color: white;
  // }
  .imgbox {
    overflow: hidden;
    position: relative;
    width: 100%;
    padding-top: 70%;
    img {
      position: absolute;
      object-fit: cover;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
